import { useEffect, useState } from 'react'
import { Link, NavLink, useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { throttle } from 'throttle-debounce'
import { Container, Nav, Navbar } from 'react-bootstrap'
import { PATHS } from 'config/routes'
import {
	HeaderPrizeSVG,
	HeaderRankSVG,
	HeaderShopSVG,
} from 'assets/svg/HeaderSVG'
import { FooterGameSVG, FooterProfileSVG } from 'assets/svg/FooterSVG'
import { useQuery } from 'react-query'
import { getUserQuery } from 'dataLayer/user'
import { getUserinfo } from 'utils/localStorage'
import { useCheckSub } from 'dataLayer/game'

const FooterMobile = () => {
	const { t } = useTranslation()
	const userInfo = getUserinfo();
	const { data: user } = useQuery(getUserQuery())
	const DOMAIN_UID = process.env.REACT_APP_DOMAIN_UID
	const CLIENTID = process.env.REACT_APP_CLIENTID
	const REDIRECT_URI = process.env.REACT_APP_REDIRECT_URI
	const location = useLocation()
	const [footerVisible, setFooterVisible] = useState(true)
	const [lastScroll, setLastScroll] = useState(0)

	const getDocHeight = () => {
		return Math.max(
			document.body.scrollHeight,
			document.documentElement.scrollHeight,
			document.body.offsetHeight,
			document.documentElement.offsetHeight,
			document.body.clientHeight,
			document.documentElement.clientHeight,
		)
	}

	const controlFooter = () => {
		throttle(250, controlledFooter())
	}

	const delta = 5
	const controlledFooter = () => {
		const st = window.scrollY
		// Make sure they scroll more than delta
		if (Math.abs(lastScroll - st) <= delta) return
		const footerHeight = document.getElementById('footer')
			? document.getElementById('footer').offsetHeight
			: 0
		// If they scrolled down and are past the navbar, add class .nav-up.
		// This is necessary so you never see what is "behind" the navbar.
		if (st > lastScroll && st > footerHeight) {
			// Scroll Down
			setFooterVisible(false)
		} else {
			// Scroll Up
			if (st < getDocHeight()) {
				setFooterVisible(true)
			}
		}

		setLastScroll(st)
	}

	useEffect(() => {
		window.addEventListener('scroll', controlFooter, { passive: true })

		return () => window.removeEventListener('scroll', controlFooter)
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [lastScroll])


	const { mutate: mutateCheckSub, isLoading: isCheckingSub } = useCheckSub(
		data => {
			if (data?.responseCode === '200') {
				window.location.href = data?.data?.urlWebView
			}
		},
	)

	const handleYes = () => {
		if (isCheckingSub) return
		mutateCheckSub({ location: 'BEAT_MOUSE', from: '' })
	}


	// TODO: Increase margin-bottom footer

	return (
		<Container
			fluid
			id="footer"
			className={`footer-mobile ${footerVisible ? '' : 'hidden'}`}
		>
			<Navbar>
				<Nav>
					<NavLink to={PATHS.HOME_PAGE}>
						<FooterGameSVG width="20" height="20" viewBox="0 0 20 20" />
						{t('mobile.footer.game')}
					</NavLink>
					<NavLink
						to={
							!userInfo
								? `${DOMAIN_UID}?client_id=${CLIENTID}&redirect_uri=${REDIRECT_URI}&use_callback_uri=true`
								: '/shop'
						}
						onClick={(e) => {
							if (userInfo) {
								e.preventDefault()
								handleYes()
							}
						}}
						replace
						state={{ previous: location.pathname }}
					>
						<HeaderShopSVG width="16" height="16" viewBox="0 0 16 16" />
						{t('header.shop')}
					</NavLink>
					<NavLink to={PATHS.PRIZE_PAGE}>
						<HeaderPrizeSVG width="22" height="20" viewBox="0 0 18 16" />
						{t('header.prize')}
					</NavLink>
					<NavLink to={PATHS.RANK_PAGE}>
						<HeaderRankSVG width="20" height="20" viewBox="0 0 18 16" />
						{t('header.rank')}
					</NavLink>
					{getUserinfo() ? (
						<NavLink to={user ? PATHS.PROFILE_PAGE : PATHS.LOGIN_PASS_MOBILE}>
							<FooterProfileSVG width="20" height="20" viewBox="0 0 20 20" />
							{t('profile.profile')}
						</NavLink>
					) : (
						<Link
							to={`${DOMAIN_UID}?client_id=${CLIENTID}&redirect_uri=${REDIRECT_URI}&use_callback_uri=true`}
						>
							<FooterProfileSVG width="20" height="20" viewBox="0 0 20 20" />
							{t('profile.profile')}
						</Link>
					)}
				</Nav>
			</Navbar>
		</Container>
	)
}

export default FooterMobile
